export default __webpack_public_path__ + "static/media/bg.3d6c4117.jpg";